/**
 * Money formatting for the explainer page.
 *
 * Deliberately NOT src/utils/format.ts aud(), which masks to $•••• for roles
 * without financial visibility. Every figure on this page is an illustrative
 * teaching example rather than studio data, so masking it would break the
 * lesson without protecting anything real.
 */
export const money = (n: number): string => {
  const rounded = Math.round(n * 100) / 100;
  const whole = rounded % 1 === 0;
  return `$${rounded.toLocaleString('en-AU', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};
